import { useMemo } from 'react'

const useUnsupportedContract = () => {
  return useMemo(() => null, [])
}

export const useERC20 = useUnsupportedContract
export const useTokenContract = useUnsupportedContract
export const useBytes32TokenContract = useUnsupportedContract
export const useWETHContract = useUnsupportedContract
export const usePairContract = useUnsupportedContract
export const useMulticallContract = useUnsupportedContract
export const useMasterchef = useUnsupportedContract
export const useSousChef = useUnsupportedContract
export const useCakeVaultContract = useUnsupportedContract
export const useCake = useUnsupportedContract
export const useENSRegistrarContract = useUnsupportedContract
export const useENSResolverContract = useUnsupportedContract
